module.exports = __webpack_public_path__ + "static/img/3.a117123.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/sp/3.png
// module id = 6mfI
// module chunks = 0